import React from 'react'
import styled from '@emotion/styled'

import Facebook from '../SocialMenu/facebook-logo-button.png'
import Instagram from '../SocialMenu/insta-social-media-logos-set.png'
import XLogo from '../SocialMenu/x-twitter.png'
import Youtube from '../SocialMenu/youtube-color.png'
import MadeBy from '../SocialMenu/madeBy.png'
import ESRB from '../ESRB'

function FooterSection({ footerMenu, socialMenu }) {
  return (
    <StyledFooter>
      <DetailsSection>
        <ContactPrivacy>
          <a href="https://cosmicforces.com/privacy-policy">Privacy Policy</a>
          <a href="https://www.cosmicforces.com/terms-of-service">Terms of Use</a>
        </ContactPrivacy>
        <ul>
          <li>
            <a href="https://www.instagram.com/cosmicforces/">
              <img src={Instagram} alt="Instagram" style={{ opacity: 0.7 }} />
            </a>
          </li>
          <li>
            <a href="https://x.com/cosmicforcesco">
              <img src={XLogo} alt="X (formerly Twitter)" style={{ opacity: 0.7 }} />
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/@GameGauntlet-Channel">
              <img src={Youtube} alt="Youtube" style={{ opacity: 0.7 }} />
            </a>
          </li>
          <li>
            <a href="https://www.cosmicforces.com">
              <img src={MadeBy} alt="Made By Cosmic Forces" />
            </a>
          </li>
        </ul>
      </DetailsSection>
      <CopyContainer>
        <ESRB rating="E10" width={70} height={91} />
        <CopyContent>
          <p>
            GOOSEBUMPS and associated logos are trademarks of Scholastic Inc. Goosebumps, the Movie
            ©2015 Columbia Pictures Industries, Inc. Goosebumps 2, the Movie ©2018 Columbia Pictures
            Industries, Inc. Goosebumps Night of Scares game software (excluding Columbia Pictures
            and Scholastic elements) ©2015 Cosmic Forces, Inc. Goosebumps Dead of Night game
            software (excluding Columbia Pictures and Scholastic elements) ©2020 Cosmic Forces, Inc.
            All Rights Reserved.
          </p>
          <p>
            Nintendo Switch is a trademark of Nintendo. The “PS” Family logo and “PS4” are
            registered trademarks of Sony Interactive Entertainment Inc. Xbox One and the Xbox logos
            are trademarks of the Microsoft group of companies and are used under license from
            Microsoft. Steam and the Steam logo are trademarks and/or registered trademarks of Valve
            Corporation in the U.S. and/or other countries.
          </p>
        </CopyContent>
      </CopyContainer>
    </StyledFooter>
  )
}

const StyledFooter = styled.footer`
  background-image: linear-gradient(to right, #1e1f1d -1%, #000000);
  padding: 3rem 6rem;
  /* display: flex; */
  justify-content: center;
  box-shadow: inset 2px 4px 12px rgba(0, 0, 0, 0.5);
  align-items: center;
  flex-wrap: wrap;
  padding: 3rem;

  @media (min-width: 1183px) {
    justify-content: space-between;
    padding: 3rem 6rem;
    flex-wrap: nowrap;
  }

  & ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    & li {
      display: inline-flex;
      align-items: center;
      margin-left: 20px;

      & img {
        vertical-align: middle;
      }

      &:last-child {
        @media (min-width: 620px) {
          border-left: 1px solid #979797;
          margin-left: 30px;
          padding-left: 30px;
        }
      }
    }
  }
`

const DetailsSection = styled.div`
  color: white;
  text-align: center;
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  a {
    color: white;
  }
  @media (min-width: 1183px) {
    text-align: left;
  }
`

const CopyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  @media (min-width: 760px) {
    justify-content: space-between;
  }
`
const CopyContent = styled.div`
  width: 90%;
  p {
    font-size: 1.2rem;
    opacity: 0.6;
    margin-right: 1rem;
    text-align: left;
  }
`

const ContactPrivacy = styled.p`
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  a {
    text-decoration: none;
  }
  a:not(:last-child) {
    margin-right: 5rem;
  }
`

export default FooterSection
